<template>
  <div
    class="flex justify-center pt-5 pb-20"
    style="
      position: absolute;
      top: 0px;
      right: 0px;
      left: 0px;
      bottom: 0px;
      margin: 0px auto;
    "
  >
    <v-stage :config="konvaConfig">
      <v-layer>
        <v-image
          v-for="(item, index) in nodeLocation"
          :key="index"
          :config="item"
          @mousedown="handleStageMouseDown"
          @transformend="handleTransformEnd"
          @dragend="handleDragend"
        ></v-image>
        <v-transformer ref="transformer" :config="transformerConfig" />
      </v-layer>
    </v-stage>
  </div>
</template>

<script>
export default {
  props: {
    konvaConfig: {
      type: Object
    },
    signature: {
      type: Object
    },
    page: {
      default: "1"
    }
  },
  data() {
    return {
      transformerConfig: {
        keepRatio: true,
        enabledAnchors: ["top-left", "top-right", "bottom-left", "bottom-right"]
      },
      signatureData: {},
      selectedImage: null,
      selectedNode: null,
      nodeLocation: []
    };
  },
  watch: {
    signature: {
      handler: "setSignature",
      deep: true
    }
  },
  methods: {
    setSignature() {
      // check jika object siganture empty
      if (this.signature.page !== undefined) {
        // check jika pindah halaman
        if (this.signatureData.page != this.signature.page)
          this.resetNodeLocation();

        this.signatureData = this.signature;
        this.signatureData.manifest.map(data => {
          this.drawSignatureImage(data);
        });
      } else {
        this.resetNodeLocation();
      }
    },
    drawSignatureImage(data) {
      const image = new window.Image();
      image.src = data.userTemplate;
      image.onload = () => {
        this.pushNodeLocation({
          data: data,
          image: image
        });
      };
    },
    pushNodeLocation({ data, image }) {
      // if new sign user use default image data
      const manifest = {
        width: data.width || image.width,
        height: data.height || image.height,
        image: image,
        draggable: true,
        x: data.x || 0,
        y: data.y || this.konvaConfig.height / 2,
        scaleX: data.scaleX || 0.0989124950055,
        scaleY: data.scaleY || 0.0989124950055,
        name: `sign-${data.userId}`
      };

      // console.dir(data.width);

      const copyData = this.nodeLocation;
      copyData.push(manifest);

      const uniqueData = this.getUniqueListBy(copyData, "name");

      this.nodeLocation = uniqueData;
    },
    resetNodeLocation() {
      this.selectedNode = [];
      this.selectedImage = [];
      this.nodeLocation = [];
      this.updateTransformer();
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    handleStageMouseDown(e) {
      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        this.selectedImage = "";
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === "Transformer";
      if (clickedOnTransformer) {
        return;
      }

      // find clicked rect by its name
      const name = e.target.name();
      const rect = this.nodeLocation.find(r => r.name === name);
      if (rect) {
        this.selectedImage = name;
      } else {
        this.selectedImage = "";
      }
      this.updateTransformer();
    },
    updateTransformer() {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const container = stage.container();
      const { selectedImage } = this;

      const selectedNode = stage.findOne("." + selectedImage);
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return;
      }

      if (selectedNode) {
        // attach to another node
        this.selectedNode = selectedNode;
        transformerNode.nodes([selectedNode]);
        container.tabIndex = 1;
        const DELTA = 1;
        let $this = this;
        container.addEventListener("keydown", function(e) {
          if (e.keyCode === 37) {
            $this.selectedNode.x($this.selectedNode.x() - DELTA);
          } else if (e.keyCode === 38) {
            $this.selectedNode.y($this.selectedNode.y() - DELTA);
          } else if (e.keyCode === 39) {
            $this.selectedNode.x($this.selectedNode.x() + DELTA);
          } else if (e.keyCode === 40) {
            $this.selectedNode.y($this.selectedNode.y() + DELTA);
          } else if (e.keyCode === 46 || e.keyCode === 8) {
            $this.deleteNode();
          } else {
            return;
          }
          e.preventDefault();
          transformerNode.getLayer().batchDraw();
        });
      } else {
        // remove transformer
        transformerNode.nodes([]);
      }
      transformerNode.getLayer().batchDraw();
    },
    handleTransformEnd(e) {
      this.setSignNodeLocation(e.target);
    },
    handleDragend(e) {
      this.setSignNodeLocation(e.target);
    },
    setSignNodeLocation(target) {
      let manifestIndex = this.nodeLocation.findIndex(
        item => item.name == target.name()
      );

      const data = {
        x: target.x(),
        y: target.y(),
        scaleX: target.scaleX(),
        scaleY: target.scaleY(),
        width: target.width(),
        height: target.height()
      };

      this.$emit("updateManifest", { data, manifestIndex });
    },
    deleteNode() {
      if (this.selectedNode) {
        let name = this.selectedNode.name();
        let locationIndex = this.nodeLocation.findIndex(i => i.name == name);

        this.nodeLocation.splice(locationIndex, 1);
        this.selectedNode = null;
        const transformerNode = this.$refs.transformer.getNode();
        transformerNode.nodes([]);

        this.$emit("deleteSign", locationIndex);
      }
    }
  }
};
</script>
